import React from "react";
import Loader from "../../../../components/Loader";
import { Container, Stack, Button, Typography, Dialog, DialogTitle, DialogContent } from "@mui/material";
import { toast, ToastContainer } from 'react-toastify';
import Page from "../../../../components/Page";
import HTTPManager from "../../../../utils/httpRequestManager";
import MerchantDataGrid from '../DataGrid';  
import FormManager from "../../../../components/formComponents/FormManager";
import schema from './schema.json';
import FButton from '../../../../components/formComponents/components/button';
import CreateMerchant from "./createMerchant";
import { checkButtonAccess } from "../../../../utils/protector"; 
import ActivateForm from './Activate/activateform';
import TerminalSettings from "./TerminalSettings";
import Payarcsettings from "./PayarcSettings";
export default class ApprovedMerchants extends React.Component{
    httpManager = new HTTPManager();

    constructor(){
        super();
        this.state={
            isLoading:false,
            userdetail:{},
            merchantsList  :[],
            selectedMerchant: {},
            viewMerchant: false,
            schema:schema,
            createMerchant: false,
            opentmform: false,
            authcode:'',
            tabName: "",
            columns:[ 
                  {
                    field: 'merchantName',
                    headerName: 'Business',
                    minWidth:250,
                    editable: false,
                    renderCell: (params) => (
                      <div className="twoLineText" title={params.row.merchantName}>
                          {params.row.merchantName}
                      </div>
                    )
                  }, 
                  {
                    field: 'merchantEmail',
                    headerName: 'Email',
                    minWidth:250,
                    editable: false,
                    renderCell: (params) => (
                      <div>
                          {params.row.merchantEmail}
                      </div>
                    )
                  },
                  {
                    field: 'merchantPhone',
                    headerName: 'Mobile',
                    minWidth:150,
                    editable: false,
                    renderCell: (params) => (
                      <div>
                          {params.row.merchantPhone}
                      </div>
                    )
                  }, 
                  {
                    field: 'ownerName',
                    headerName: 'Owner Name',
                    minWidth:150,
                    editable: false,
                    renderCell: (params) => (
                      <div className="twoLineText" title={params.row.ownerName === '' || params.row.ownerName === null ? '--' : params.row.ownerName}>
                        {params.row.ownerName === '' || params.row.ownerName === null ? '--' : params.row.ownerName}
                      </div>
                    )
                  },
                  {
                    field: 'merchantSyncCode',
                    headerName: 'Sync Code',
                    minWidth:100, 
                    editable: false,
                    renderCell: (params) => (
                      <div>
                        {params.row.syncCode === null || params.row.syncCode === undefined ? '--' : params.row.syncCode}
                      </div>
                    )
                  },
                  {
                    field: 'ownerPasscode',
                    headerName: 'Passcode',
                    minWidth:50,
                    editable: false,
                    renderCell: (params) => (
                      <div>
                        {params.row.ownerPasscode === null || params.row.ownerPasscode === undefined ? '--' : params.row.ownerPasscode}
                      </div>
                    )
                  },
                  {
                    field:'',
                    headerName:'Actions', 
                    minWidth:250, flex: 1,
                    editable: false,
                    renderCell: (params)=>(
                        <div style={{display:'flex', flexDirection:'row'}}>  
                            {( this.state.userdetail.userRole === 'SuperAdmin' || this.state.userdetail.userRole === 'Admin') &&<div > 
                                            <Button variant="contained" onClick={()=>{
                                                this.viewDetail(params.row)
                                            }}>View</Button>  
                                            </div>
                            }  

                            {( this.state.userdetail.userRole === 'SuperAdmin' || this.state.userdetail.userRole === 'Admin') &&<div style={{ marginLeft: '5px' }}> 
                                            <Button variant="contained" color="error" onClick={()=>{
                                                this.setState({ selectedMerchant: params.row }, () => {
                                                    this.onDeactivate();
                                                });
                                            }}>Deactivate</Button>  
                                            </div>
                            }  

                            {params.row.isVerified!==1 && this.state.userdetail.id !== params.row.id && params.row.merchantEmail !== '' && params.row.merchantEmail !== null &&
                                <FButton permission_id = "web_resendmail_employee" permission_label="Show resendmail employee"
                                variant="contained" 
                                size="small" 
                                onClick={()=>{this.setState({authcode:params.row.verfificationURL})}} 
                                label="Activate"/>
                            }
                            {params.row.isVerified!==1 && this.state.userdetail.id !== params.row.id && params.row.merchantEmail !== '' && params.row.merchantEmail !== null &&
                                <FButton permission_id = "web_resendmail_employee" permission_label="Show resendmail employee"
                                variant="contained" 
                                size="small" 
                                onClick={()=>{this.resendmail(params.row)}} 
                                label="Resend Email"/>
                            }
                            {
                                params.row.toResetPOs.length> 0 && <div>
                                     <FButton permission_id = "web_resendmail_employee" permission_label="Show resendmail employee"
                                        variant="contained" 
                                        size="small" 
                                        onClick={()=>{this.resetDevice(params.row)}} 
                                        label="Reset Device"/>
                                </div>
                            }

                        </div>
                    )
                  }
            ], 
        }
        this.viewDetail = this.viewDetail.bind(this);
        this.setFormDetails = this.setFormDetails.bind(this);
        this.onDeactivate = this.onDeactivate.bind(this);
        this.resendmail = this.resendmail.bind(this);
        this.resetDevice = this.resetDevice.bind(this);
        this.handletmclose = this.handletmclose.bind(this);
        this.reloadData = this.reloadData.bind(this)
    }

    resetDevice(row){
        this.setState({isLoading: true}, ()=>{
            this.httpManager.postRequest(`pos/resetPOS`, {merchantId: row.merchantId}).then(res=>{ 
                this.setState({isLoading: false});
                this.reloadData(res.msg);
            })
        })
    }

    resendmail(row){
        this.setState({isLoading: true}, ()=>{
            this.httpManager.postRequest(`common/resendMail`, {userType: "M", userId: row.mEmployeeId}).then(res=>{ 
                this.setState({isLoading: false});
                this.reloadData(res.message);
            })
        })
    }


    setFormDetails(){
        this.setState({isLoading: true})
        var data = Object.assign({}, this.state.selectedMerchant);
        var schema = Object.assign({}, this.state.schema);
        var propslist = Object.assign([], this.state.schema.properties);
        var properties = [];
        propslist.forEach((field, i)=>{ 
            field.value = data[field.name];
            // field.disabled=true;
            properties.push(field);
            if(i === propslist.length-1){ 
                properties.push({
                    "component":"TextField", 
                    "type": "hidden", 
                    "minLength": 1,
                    "maxLength": 50,
                    "grid":6,
                    "name":"id",
                    "label":"id",
                    "placeholder":"id",
                    "value":data.id
                  })
                //console.log(properties)
                schema.properties = properties
                this.setState({schema: schema},()=>{
                    this.setState({isLoading: false, viewMerchant: true})
                })
            }
        })
    }

    componentDidMount(){
        console.log(this.props)
        var details  = window.localStorage.getItem('userdetail');
        if(details !== undefined && details !== null && details !== ''){
            this.setState({userdetail: JSON.parse(details)}, ()=>{
                this.reloadData();
            })
        } 
    }

    reloadData(msg=''){
        if(msg !== ''){
            toast.dismiss();
            toast.success(msg, {
                position: "top-center",
                autoClose: 5000,
                closeButton:false,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }

        this.setState({tabname: "", viewMerchant: false, opentmform: false, isLoading: true}, ()=>{
            this.httpManager.postRequest(`merchant/getApprovedMerchants`,{}).then(response=>{
               this.setState({merchantsList: response.data, isLoading:false});
            })

        })
    }  

    onDeactivate(){
        this.setState({ isLoading: true }, () => {
            var detail = Object.assign({}, this.state.selectedMerchant)
            var input = {
                id: detail.id,
                merchantStatus: 'Deactivated'
            }

            this.httpManager.postRequest(`merchant/verify/deactivateMerchant`, input).then(res=>{
                this.setState({selectedMerchant:{}})
                this.reloadData(res.message)
            }).catch(err => {
                this.setState({ isLoading: false })
                toast.error(err.message || "Failed to deactivate merchant.")
            })
        })
    }     

    viewDetail(detail){
        this.setState({selectedMerchant: detail, tabName: "review"}, ()=>{
            this.setFormDetails()
        })
    }

    handletmclose(){
        this.reloadData()
    }

    render(){
        return  <Page title="Approved Merchant | Astro POS">
          {this.state.isLoading && <Loader />}
          <ToastContainer 
            position="top-center"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss={false}
            draggable={false}
            pauseOnHover={false}
            />

            {(this.state.viewMerchant || this.state.opentmform) && (
                <div className="tab"> 
                        <button  className={this.state.tabName === 'review' ? "active tablinks": "tablinks"} 
                        onClick={()=>{ 
                            this.setState({tabName:'review', viewMerchant: true, opentmform: false})
                        }}> MERCHANT DETAILS</button> 

                        <button className={this.state.tabName === 'tmsettings' ? "active tablinks": "tablinks"} 
                        onClick={()=>{ 
                            this.setState({tabName:'tmsettings', viewMerchant: false, opentmform: true})
                        }} >TERMINAL SETTINGS</button>
                        <button className={this.state.tabName === 'payarcsettings' ? "active tablinks": "tablinks"} 
                        onClick={()=>{ 
                            this.setState({tabName:'payarcsettings', viewMerchant: false, opentmform: true})
                        }} >PAYARC SETTINGS</button>
                    </div>
                )}

        <Container maxWidth="xl">

        {!this.state.viewMerchant && !this.state.createMerchant && !this.state.opentmform && <><Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>

        
        <div style={{width:'100%', display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
                <Typography variant="h4" gutterBottom>
                    Approved Merchants
                </Typography> 
            
                {(checkButtonAccess('Merchant.Create') === 'Y' || checkButtonAccess('Merchant.Create') === 'W') && <Button variant="contained" onClick={()=>{
                    this.setState({createMerchant: true})
                }}>Create Merchant</Button>}
            </div> 

            </Stack> 
            <MerchantDataGrid columns={this.state.columns} data={this.state.merchantsList} showAssignee={false}  assignees={[]}/>
                        </>} 

                        {this.state.authcode !== '' && <Dialog open={this.state.authcode !== ''}>
                            <DialogTitle>
                                Activate    
                            </DialogTitle>    
                            <DialogContent>
                                <ActivateForm authcode={this.state.authcode} closeForm={()=>{
                                    this.setState({authcode:''},()=>{
                                        this.reloadData();
                                    })
                                }} />
                            </DialogContent>
                        </Dialog>}

                {this.state.createMerchant && <CreateMerchant closeForm={()=>{
                    this.setState({createMerchant: false}, (msg)=>{
                        this.reloadData(msg);
                    })
                }} />}
        {this.state.viewMerchant && <FormManager formProps={this.state.schema} reloadData={()=>{
                                this.reloadData()
                            }} closeForm={(action='', formData={})=>{
                                //console.log(action, formData)
                                if(action === ''){
                                    this.setState({viewMerchant: false, selectedMerchant: {}})
                                }
                                if(action==='Deactivate'){
                                    this.onDeactivate();
                                } 
                            }}/>}

        {!this.state.viewMerchant && this.state.opentmform && this.state.tabName==="tmsettings" && (
        <TerminalSettings merchant={this.state.selectedMerchant} closeForm={this.handletmclose} />
        )}

        {!this.state.viewMerchant && this.state.opentmform && this.state.tabName==="payarcsettings" && (
        <Payarcsettings merchant={this.state.selectedMerchant} closeForm={this.handletmclose} />
        )}
            </Container>
        </Page>
    }
}